import * as React from 'react';
import { useState } from 'react';
import {
    DEFAULT_ICON,
    FruitfulCustomIcon,
    H5Emphasized,
    View,
    YStack,
} from 'smoothie';

import type { UpdateBankAccountInfo } from '../../../../types/BankAccount';
import CreateEditButton from './CreateEditButton';
import IconSelection from './IconSelection';

interface IconProps {
    onPressNext: (updates?: Partial<UpdateBankAccountInfo>) => void;
    accountInfo: UpdateBankAccountInfo;
}

const Icon = ({ onPressNext, accountInfo }: IconProps) => {
    const [icon, setIcon] = useState(accountInfo.icon);

    return (
        <YStack height="100%" justifyContent="space-between">
            <View>
                <View alignSelf="center">
                    <FruitfulCustomIcon
                        icon={icon}
                        color={accountInfo.color}
                        size="xl"
                        showShadow
                    />
                </View>
                <H5Emphasized textAlign="center" marginTop={24}>
                    {accountInfo.nickname}
                </H5Emphasized>
            </View>
            <YStack gap={16}>
                <IconSelection
                    selectedIcon={icon ?? DEFAULT_ICON}
                    onSelect={(icon) => {
                        setIcon(icon);
                    }}
                />
                <CreateEditButton
                    disabled={icon == null}
                    onPress={() => {
                        onPressNext({ icon });
                    }}
                />
            </YStack>
        </YStack>
    );
};

export default Icon;
